export const init = () => {
    let deletedLinks = [];
    function removeLinks() {
        const nav = document.querySelector('.js-breadcrumb');
        const popup = document.querySelector('.js-breadcrumb-popup');
        const links = nav.querySelectorAll('.js-breadcrumb-link');
        let linksWidth = 0;
        links.forEach((item) => {
            linksWidth += item.getBoundingClientRect().width;
        });
        if (linksWidth > (nav.getBoundingClientRect().width - 47)) {
            if (!nav.querySelector('.js-show-links')) {
                const elem = document.createElement('li');
                const anchor = document.createElement('a');
                elem.classList.add('s-breadcrumb__link', 'js-breadcrumb-link', 'js-show-links');
                const node = document.createTextNode('...')
                anchor.appendChild(node);
                elem.appendChild(anchor);
                nav.insertBefore(elem, nav.children[1]);
                linksWidth += elem.getBoundingClientRect().width;
            }
            while (linksWidth > (nav.getBoundingClientRect().width - 47)) {
                linksWidth -= nav.children[2].getBoundingClientRect().width;
                deletedLinks.push(nav.children[2]);
                nav.children[2].remove();
            }
            const ul = document.createElement('ul');
            deletedLinks.forEach((item) => ul.appendChild(item));
            popup.appendChild(ul);
            nav.querySelector('.js-show-links').addEventListener('mouseenter', () => {
                popup.classList.add('active');
            });
            nav.querySelector('.js-show-links').addEventListener('mouseleave', () => {
                popup.classList.remove('active');
            });
            popup.addEventListener('mouseenter', () => {
                popup.classList.add('active');
            });
            popup.addEventListener('mouseleave', () => {
                popup.classList.remove('active');
            });
        }
    }
    if (document.querySelector('.js-breadcrumb')) {
        removeLinks();
        window.addEventListener('resize', (e) => {
            e.preventDefault();
            removeLinks();
        })
    }
}